import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { SxProps, Theme } from "@mui/material/styles";

interface ISpinnerProperties {
  sx?: SxProps<Theme>;
}

/**
 * Spinner component that displays a centered, circular progress indicator.
 *
 * @param sx - Optional additional styling for the spinner.
 */
export default function Spinner({ sx = {} }: ISpinnerProperties) {
  return (
    <Box
      sx={{
        ...sx,
        display: "flex",
        flexGrow: 1,
        justifyContent: "center",
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
}
